import { TableColumnsType } from "antd";
import { DataColumnConfig } from "src/hooks/useTransformDataColumns";
import { Configuration } from "src/models/ConfigurationModel";
import EditModal from "./EditModal";
import { CLAIMS } from "src/constants";

export type ConfigurationWithActions = Configuration & {
  actions?: void;
};

export const config: DataColumnConfig<ConfigurationWithActions> = {
  key: { searchType: "text" },
  actions: {
    claims: CLAIMS.EDIT,
  },
};

export const columns: TableColumnsType<ConfigurationWithActions> = [
  {
    title: "Key",
    key: "key",
    dataIndex: "key",
    ellipsis: true,
    render: (value) => <span>{value ? value : "_"}</span>,
  },
  {
    title: "Value",
    key: "value",
    dataIndex: "value",
    ellipsis: true,
    render: (value) => <span>{value ? value : "_"}</span>,
  },
  {
    title: "Category",
    key: "category",
    dataIndex: "category",
    ellipsis: true,
    render: (value) => <span>{value ? value : "_"}</span>,
  },
  {
    title: "Validation",
    key: "validation",
    dataIndex: "validation",
    ellipsis: true,
    render: (value) => <span>{value ? value : "_"}</span>,
  },
  {
    title: "Actions",
    key: "actions",
    fixed: "right",
    ellipsis: true,
    className: "bg-white",
    render: (record: any) => <EditModal configKey={record?.key} />,
  },
];
